import { globals } from './';
export function getExpirationTimestamp(expiresIn) {
    return Date.now() + +expiresIn * 1000;
}
// Ignore this function for test coverage purposes for now
/* istanbul ignore next */
export async function getOAuthToken() {
    var _a, _b, _c;
    try {
        const deviceType = ((_c = (_b = (_a = globals) === null || _a === void 0 ? void 0 : _a.amznMusic) === null || _b === void 0 ? void 0 : _b.appConfig) === null || _c === void 0 ? void 0 : _c.deviceType) || process.env.deviceType;
        let deviceTypeParam = '';
        if (deviceType) {
            deviceTypeParam = `?deviceType=${deviceType}`;
        }
        const response = await globals.fetch('/horizonte/pandaToken' + deviceTypeParam, {
            method: 'get',
        });
        const json = await response.json();
        if (json.error) {
            return { accessToken: '', expiresAt: Date.now() + 900 };
        }
        return {
            accessToken: json.accessToken,
            expiresAt: getExpirationTimestamp(json.expiresIn),
        };
    }
    catch (e) {
        // Default to empty token if error, will show bourne experience
        return { accessToken: '', expiresAt: Date.now() + 900 };
    }
}
